import React, { useCallback, useState } from 'react';
import { t } from 'i18next';
import { Popup } from 'devextreme-react/popup';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import FormWrapper from '@/core/wrappers/form-wrapper';
import { auditLogService } from '@/projects/admin/services/audit-log-service';
import CustomStore from 'devextreme/data/custom_store';


const App = () => {
    const [mainStore] = useState(new CustomStore({
        key: ['id'],
        load: auditLogService.getAuditLogs,
        byKey: async (key, loadOptions: any) => {
            let returnObject = null;
            if (key) {
                loadOptions.filter = ["id", "=", key];
                const objectsByID = (await auditLogService.getAuditLogs(loadOptions))
                returnObject = objectsByID.data.length > 0 ? objectsByID.data[0] : null;
            }
            return returnObject
        },
        useDefaultSearch: true
    }));

    const [currentRow, setCurrentRow] = useState({ oldValue: '', newValue: '' });
    const [popupVisible, setPopupVisible] = useState(false);

    const showInfo = useCallback((e: any) => {
        let newValueContent = '';
        if (e.row.data.newValue !== null && e.row.data.newValue !== undefined && e.row.data.newValue !== '') {
            const newValueObject = JSON.parse(e.row.data.newValue);
            for (const key in newValueObject) {
                if (Object.hasOwnProperty.call(newValueObject, key)) {
                    newValueContent += `${key}: ${newValueObject[key]}\n`;
                }
            }
        }

        let oldValueContent = '';
        if (e.row.data.oldValue !== null && e.row.data.oldValue !== undefined && e.row.data.oldValue !== '') {
            const oldValueObject = JSON.parse(e.row.data.oldValue);
            for (const key in oldValueObject) {
                if (Object.hasOwnProperty.call(oldValueObject, key)) {
                    oldValueContent += `${key}: ${oldValueObject[key]}\n`;
                }
            }
        }
        setCurrentRow({ oldValue: oldValueContent, newValue: newValueContent });
        setPopupVisible(true);
    }, [setCurrentRow, setPopupVisible]);

    const hideInfo = useCallback(() => {
        setCurrentRow({ oldValue: '', newValue: '' });
        setPopupVisible(false);
    }, [setCurrentRow, setPopupVisible]);

    return (

        // <SingleCard title={t("audit_logs")}>
        <React.Fragment>
            <DataGridWrapper
                datasource={mainStore}
                pagerVisible={true}
                filterVisible={true}
                headerFilterVisible={true}
                enableCustomToolbarContent={true}
                editingConfig={{
                    mode: "row",
                    useIcons: true,
                    allowUpdating: true,
                }} buttonConfig={[
                    {
                        name: 'edit',
                        icon: 'eyeopen',
                        onClick: showInfo
                    }
                ]}
                columns={[
                    {
                        dataField: 'entityId',
                        caption: t('entity_id')
                    },
                    {
                        dataField: 'entityName',
                        caption: t('entity_name'),
                        dataType: 'string',
                        allowFiltering: true
                    },
                    {
                        dataField: 'timestamp',
                        dataType: 'datetime',
                        format: 'dd.MM.yyyy',
                        caption: t('time_stamp')
                    },
                    {
                        dataField: 'action',
                        caption: t('action'),
                        allowFiltering: true
                    },
                    {
                        dataField: 'userName',
                        caption: t('user_name')
                    },
                    {
                        dataField: 'userId',
                        caption: t('user_id'),
                        visible: false
                    }
                ]}

            />

            <Popup
                visible={popupVisible}
                onHiding={hideInfo}
                title={t('audit_log_info')} // Popup başlığı
                showTitle={true}
                width={1000}
                height={400}
                position={{
                    of: window, // Pencereye göre konumlandır
                    at: 'center', // Ortala
                    my: 'center' // Kendi merkezini kullan
                }}
            >
                <FormWrapper
                    formData={currentRow}
                    simpleItemGroups={[
                        {
                            cssClass: 'form-group',
                            useColCountByScreen: true,
                            items: [
                                {
                                    dataField: 'oldValue',
                                    editorType: 'dxTextArea',
                                    editorOptions: {
                                        value: currentRow.oldValue,
                                        elementAttr: {
                                            style: 'background-color: #FF9999; height: 200px;'
                                        }
                                    },
                                    label: 'old_value'
                                },
                                {
                                    dataField: 'newValue',
                                    editorType: 'dxTextArea',
                                    editorOptions: {
                                        value: currentRow.newValue,
                                        elementAttr: {
                                            style: 'background-color: #CCFFE5;height: 200px;'
                                        }
                                    },
                                    label: 'new_value'
                                }
                            ]
                        }
                    ]}
                />
            </Popup>
        </React.Fragment>


    );
};

export default App;